/*
 * `return_to` validator — same-origin path only.
 * The backend (Story 1.8 validateReturnTo) does the authoritative validation;
 * this is a defensive frontend check so we never call router.push with a
 * known-bad value.
 */

const PATH_RE = /^\/(?!\/)[A-Za-z0-9_\-./?&=%:#]*$/;
// eslint-disable-next-line no-control-regex
const CONTROL_RE = /[\x00-\x1f\x7f]/;

export function isValidReturnTo(value) {
  if (typeof value !== 'string' || value.length === 0) return false;
  if (value.length > 2048) return false;
  if (CONTROL_RE.test(value)) return false;
  if (!PATH_RE.test(value)) return false;
  // Defensive: protocol-relative URLs slipping past the leading-slash gate.
  if (value.startsWith('//')) return false;
  return true;
}

export function safeReturnTo(value, fallback = '/') {
  return isValidReturnTo(value) ? value : fallback;
}
